module.exports = __webpack_public_path__ + "static/media/cat_manual_number.c4257425.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat_manual_number.png
// module id = 483
// module chunks = 0